'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEPAPaymentFormContainer = exports.mapStateToProps = undefined;

var _reactIntl = require('react-intl');

var _reactRedux = require('react-redux');

var _decorator = require('helpers/decorator');

var _countriesServed = require('constants/countries-served');

var _SEPAPaymentForm = require('components/PaymentMethods/SEPAPaymentForm/SEPAPaymentForm');

var _withStripeElements = require('components/PaymentMethods/withStripeElements');

var mapStateToProps = exports.mapStateToProps = function mapStateToProps(state, _ref) {
  var countryCode = _ref.countryCode;
  return {
    countryShortCode: _countriesServed.COUNTRY_CODE_TO_SHORT_CODE[countryCode]
  };
};

var SEPAPaymentFormContainer = exports.SEPAPaymentFormContainer = (0, _decorator.decorateWith)(_withStripeElements.withStripeElements, _reactIntl.injectIntl, (0, _reactRedux.connect)(mapStateToProps))(_SEPAPaymentForm.SEPAPaymentForm);